// extracted by mini-css-extract-plugin
export default {"container":"header-module_container_lSdR_b","logo":"header-module_logo_NNNOAB"};